import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'

import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade'

import { primaryEmailFromContact } from '../hooks/primaryEmailFromContact'
import { useHasValidMeetingBriefCacheFromHost } from '../hooks/useHasValidMeetingBriefCacheFromHost'
import { useOpenMeetingPrepFromHost } from '../hooks/useOpenMeetingPrepFromHost'

export const GenerateMeetingPrep = ({ contact, meeting }) => {
  const openMeetingPrep = useOpenMeetingPrepFromHost()
  const enforceUpgrade = useEnforceUpgrade('crm_meeting_prep', {
    skipPreface: true,
  })
  const hasCachedMeetingBrief = useHasValidMeetingBriefCacheFromHost(
    contact,
    meeting,
  )

  const handleGenerateMeetingPrep = (e) => {
    e.preventDefault()
    e.stopPropagation()
    enforceUpgrade(() => {
      openMeetingPrep(
        {
          id: contact.id,
          email: primaryEmailFromContact(contact),
          name: contact.fullName ?? contact.name,
        },
        meeting,
      )
    })
  }

  return (
    <Button
      data-testid="generate-meeting-prep"
      data-tracking-action="generate_meeting_prep"
      data-tracking-location="meetings_page"
      size="small"
      onClick={handleGenerateMeetingPrep}
      decoration="ai"
      responsive={false}
    >
      {hasCachedMeetingBrief
        ? I18n.t('publisher.contacts.buttons.view_meeting_prep')
        : I18n.t('publisher.contacts.buttons.generate_meeting_prep')}
    </Button>
  )
}
